import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, TextField, Autocomplete } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "../Dialog";
import Autocomplete2 from "../Autocomplete2";
import { gridStyle } from "../../utils/formStyles";
import { handleError } from "../../reducers/ErrorReducer";
import { notify } from "../../reducers/NotifierReducer";
import {
  findSecCode,
  getGroup,
  updateGroup,
} from "../../pages/Security/SecFunction";
import { closeEditSecRole } from "../../reducers/DialogsReducer";
import { notifyDataUpdate } from "../../reducers/DataUpdateReducer";

const EditSecRoleDialog = (props) => {
  const { groupId } = props;
  const { ptsAgencies } = props.dictionary.dictionary;
  const [name, setName] = useState("");
  const [currentType, setCurrentType] = useState(null);
  const [currentAgency, setCurrentAgency] = useState(null);
  const [allTypes, setAllTypes] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const types = await findSecCode("grouptype");
    setAllTypes(types);
    const group = await getGroup(groupId);
    setName(group.Label);
    const curAgency = Array.isArray(ptsAgencies)
      ? ptsAgencies.find((ag) => ag.AgencyID === group.AgencyID)
      : null;
    setCurrentAgency(curAgency || null);
    setCurrentAgency(curAgency || null);
    const curType = types.find((type) => type.Code === group.Type);
    setCurrentType(curType || null);
  };

  const close = () => {
    props.closeEditSecRole();
  };

  const save = async () => {
    const data = {
      Label: name,
      Type: currentType?.Code || null,
      AgencyID: currentAgency?.AgencyID || null,
    };
    try {
      const result = await updateGroup(groupId, data);
      props.notifyDataUpdate({ type: "edit-role", data: result.ptsGroupID });
      props.notify("Role Updated", "success");
      props.closeEditSecRole();
    } catch (err) {
      props.handleError(err, "Error Updating Role");
    }
  };

  const renderActions = () => (
    <>
      <Button
        color="primary"
        variant="contained"
        autoFocus
        onClick={save}
        disabled={!name}
        startIcon={<SaveIcon />}
      >
        Save
      </Button>
      <Button color="primary" onClick={close} startIcon={<CloseIcon />}>
        Close
      </Button>
    </>
  );

  const renderName = () => (
    <TextField
      label="Role Name"
      variant="outlined"
      value={name}
      size="small"
      onChange={(e) => setName(e.target.value)}
      fullWidth
    />
  );

  const renderType = () => {
    const handleChange = (e, newValue) => setCurrentType(newValue);
    return (
      <Autocomplete
        className="mt-3"
        disablePortal
        options={allTypes}
        renderInput={(params) => (
          <TextField {...params} label="Role Type" variant="outlined" />
        )}
        onChange={handleChange}
        getOptionLabel={(option) => option.Code}
        isOptionEqualToValue={(option, value) => option.Code === value.Code}
        renderOption={(props, option) => (
          <li {...props}>
            {option.Code} {option.Description ? `- ${option.Description}` : ""}
          </li>
        )}
        size="small"
        value={currentType}
      />
    );
  };

  const renderAgency = () => {
    const handleChange = (e, newValue) => setCurrentAgency(newValue);

    return (
      <div className="mt-3">
        <Autocomplete2
          options={ptsAgencies || []}
          sx={{ ...gridStyle(200, 800) }}
          onChange={handleChange}
          value={currentAgency}
          label="Agency"
          getOptionLabel={(option) => option.AgencyID || ""}
          isOptionEqualToValue={(option, value) =>
            option.AgencyID === value?.AgencyID
          }
          renderOption={(props, option) => (
            <li {...props}>{option.AgencyID}</li>
          )}
        />
      </div>
    );
  };

  return (
    <Dialog onClose={close} title="Edit Role" actions={renderActions()}>
      <div>
        {renderName()}
        {renderType()}
        {renderAgency()}
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  dictionary: state.dictionary,
});

export default connect(mapStateToProps, {
  closeEditSecRole,
  handleError,
  notify,
  notifyDataUpdate,
})(EditSecRoleDialog);
